import { render, staticRenderFns } from "./VilageV2.vue?vue&type=template&id=08a6cf70"
import script from "./VilageV2.vue?vue&type=script&lang=js"
export * from "./VilageV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports